<template>
  <div class="block-wrap">
    <div class="content-wrap">
      <h3>学会职能“一键达”</h3>
      <p class="content-desc">Functions of The Landscape Architecture</p>
      <div class="entrys-wrap">
        <div class="entry-info">
          <div class="entry-info-title">
            <img src="../../assets/images/xhtg-title.png" alt="">
            <div>学会投稿</div>
          </div>
          <div class="entry-info-desc">
            为进一步丰富稿件内容,提升论文质量,现向您征稿,欢迎踊跃投稿。
          </div>
        </div>
        <div class="entry-value">
          <div class="entry-value-item">
            <img src="../../assets/images/lhxx-logo.png" alt="">
            <div @click="linkTo('/contribution/zjyllhxx')">
              <h4>浙江园林绿化信息</h4>
              <p>浙江园林绿化信息</p>
            </div>
          </div>
          <div class="entry-value-item">
            <img src="../../assets/images/ylzz-logo.png" alt="">
            <div @click="linkTo('/contribution/zjylzz')">
              <h4>浙江园林杂志</h4>
              <p>学术交流性行业刊物</p>
            </div>
          </div>
        </div>
        <div class="entry-info member">
          <div class="entry-info-title">
            <img src="../../assets/images/hyzc-title.png" alt="">
            <div>会员注册</div>
          </div>
          <div class="entry-info-desc">
            会员注册副标题文案会员注册 副标题文案
          </div>
        </div>
        <div class="entry-value">
          <div class="entry-value-item">
            <img src="../../assets/images/tthyzc-logo.png" alt="">
            <div @click="linkTo('/member/group/register')">
              <h4>团体会员注册</h4>
              <p>团体会员注册入口</p>
            </div>
          </div>
          <div class="entry-value-item">
            <img src="../../assets/images/grhyzc-logo.png" alt="">
            <div @click="linkTo('/member/person/register')">
              <h4>个人会员注册</h4>
              <p>个人会员注册入口</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router';
export default {
  data() {
    return {}
  },
  methods: {
    linkTo(uri) {
      router.push(uri);
    }
  }
}
</script>

<style lang="less" scoped>
.block-wrap {
  background: url('http://ylxh-service.oss-cn-hangzhou.aliyuncs.com/institute-bg.jpg') no-repeat center center;
  background-size: 100% 100%;
}
.content-wrap {
  padding: 30px 0 30px;
  > h3 {
    height: 32px;
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #131415;
    line-height: 32px;
    margin-bottom: 10px;
    text-align: center;
  }

  .content-desc {
    height: 18px;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #131415;
    line-height: 18px;
    margin-bottom: 30px;
    text-align: center;
  }

  .entrys-wrap {
    width: 100%;
    display: flex;

    > div {
      height: 306px;
    }

    .entry-info {
      width: 276px;
      background: #F7FCFA url(../../assets/images/xhtg_bg.png) no-repeat center center;
      background-size: 100% 100%;
      padding: 40px 36px 0 32px;

      &.member {
        background-image: url(../../assets/images/hyzh_bg.png);
      }

      &-title {
        display: flex;
        align-items: center;
        font-size: 24px;
        font-family: PingFang-SC-Bold, PingFang-SC;
        font-weight: bold;
        color: #FFFFFF;
        letter-spacing: 2px;
        margin-bottom: 11px;

        img {
          width: 42px;
          height: 42px;
          margin-right: 10px;
        }
      }

      &-desc {
        font-size: 16px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 24px;
      }
    }

    .entry-value {
      flex: 1;
      padding: 22px;
      background: #F7FCFA;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      &-item {
        width: 100%;
        padding: 0 12px;
        height: 120px;
        background: #FFFFFF;
        border: 1px solid rgba(47,194,91,0.12);
        display: flex;
        align-items: center;

        > img {
          width: 60px;
          height: 60px;
          margin-right: 10px;
        }

        > div {
          height: 60px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          cursor: pointer;

          h4 {
            font-size: 20px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #131415;
          }

          p {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #787878;
          }
        }
      }
    }
  }
}
</style>